import { combineReducers } from '@reduxjs/toolkit'
import projectsReport from './projects_report'

export default combineReducers({
  projectsReport
})
